module.exports = __webpack_public_path__ + "static/zqb_3.69288538.png";